import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "brand-company",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: this.$route.query.id || ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    refund: function refund(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this2.$api.getMemberRefund({
                id: row.id
              });
            case 1:
              res = _context3.v;
              _this2.$confirm("\u8BE5\u8BA2\u5355\u652F\u4ED8<strong>".concat(row.amount, "</strong>\u5143\uFF0C\u5E94\u9000\u6B3E<strong>").concat(res.data.amount, "</strong>\u5143\u3002"), "会员退款", {
                confirmButtonText: "确定退款",
                confirmButtonClass: "el-button--danger",
                cancelButtonText: "取消",
                type: "warning",
                dangerouslyUseHTMLString: true
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return _this2.$api.memberRefund({
                        id: row.id
                      });
                    case 1:
                      // 操作上报
                      _this2.$operationLog.push({
                        operationType: "order",
                        operationOrderType: "member_refund",
                        code: "refund",
                        userId: row.user_info.id,
                        detailBatchNo: row.id
                      });
                      _this2.$message.success("操作成功");
                      _this2.getData();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }))).catch(function () {});
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context4.n = 1;
              return _this3.$api.getMemberOrderList(_this3.searchForm);
            case 1:
              res = _context4.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "user_id");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};